<template>
  <div
    class="theme-calendar"
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--is-dirty': isDirty,
      'theme-input__field-holder--is-disabled': disabled
    }"
    :data-vv-as="label"
    data-vv-value-path="model"
  >
    <label class="theme-input__label" v-if="label">{{label}}
      <span v-if="isRequired" class="theme-input__label-asterisk">*</span>
    </label>
    <div class="theme-calendar__wrapper">
      <input
        class="theme-input theme-input--extra"
        v-model="model"
        type="text"
        @change="$emit('input', model)"
        ref="picker"
        @focus="show"
        @blur="dateMask ? onDateBlur() : hide()"
        :name="name"
        @input="dateMask ? onDateInput($event) : $emit('input', model)"
        @paste="dateMask ? onDatePaste($event) : null"
        v-validate="`date_format:DD-MM-YYYY`"
        :disabled="disabled"
        :placeholder="placeholder"
        :inputmode="dateMask ? 'numeric' : undefined"
        :maxlength="dateMask ? 10 : undefined"
      >
      <div class='theme-input__extra-info'>
        <span class="icon-calendar"/>
      </div>
      <span v-if="errors.has(newName)" class="theme-input__icon theme-input__icon-error icon-warning"></span>
      <input type="hidden" v-model="hidden" :name="name">
    </div>
    <div class="theme-input__error-text" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
import field from "../admin/mixins/field";
import $ from "jquery";
import "tempusdominus-bootstrap-4";

export default {
  computed: {
    hidden() {
      if (this.model) {
        let datetime = this.model.split(" ");
        let date = datetime[0].split("-");
        let time = "";

        if (datetime[1]) {
          time = " " + datetime[1];
        }
        return date[0] && date[1] && date[2]
          ? `${date[2]}-${date[1]}-${date[0]}${time}`
          : "";
      }

      return "";
    }
  },
  mounted() {
    moment.updateLocale("en", {
      week: { dow: 1 } // Monday is the first day of the week
    });
    var todayDate = moment().startOf('day');
    if (!this.pastDates) {
      $(this.$refs.picker).datetimepicker({
        format: this.format,
        minDate: todayDate
      });
    } else {
      var config = { format: this.format };
      if (this.decades) {
        config.viewMode = "years";
      }
      if (this.maxDate) {
        config.maxDate = moment(this.maxDate, "YYYY-MM-DD");
        config.viewDate = moment(this.maxDate, "YYYY-MM-DD");
        config.useCurrent = false;
      }
      $(this.$refs.picker).datetimepicker(config);
    }

    $(this.$refs.picker).on("input.datetimepicker", e => {
      this.model = e.target.value;
    });
  },
  methods: {
    show() {
      $(this.$refs.picker).datetimepicker("show");
      if (this.decades) {
        $(this.$refs.picker).datetimepicker("viewMode", "years");
      }
    },
    hide() {
      $(this.$refs.picker).datetimepicker("hide");
    },
    sanitizeDate(value) {
      var digits = value.replace(/[^0-9]/g, '');
      var result = '';
      for (var i = 0; i < digits.length && result.length < 10; i++) {
        if (result.length === 2 || result.length === 5) result += '-';
        result += digits[i];
      }
      return result;
    },
    onDateInput(event) {
      this.model = this.sanitizeDate(event.target.value);
      this.$emit('input', this.model);
      var self = this;
      this.$nextTick(function() { self.$refs.picker.value = self.model; });
    },
    onDatePaste(event) {
      event.preventDefault();
      var pasted = (event.clipboardData || window.clipboardData).getData('text');
      this.model = this.sanitizeDate(pasted);
      this.$emit('input', this.model);
    },
    onDateBlur() {
      this.hide();
      if (!this.model || this.model.length === 0) return;
      if (this.model.length < 10) return;
      var self = this;
      var date = moment(this.model, 'DD-MM-YYYY', true);
      if (!date.isValid()) {
        this.model = '';
        this.$emit('input', this.model);
        this.$nextTick(function() { self.$validator.validate(self.name); });
        return;
      }
      if (this.maxDate) {
        var max = moment(this.maxDate, 'YYYY-MM-DD');
        if (date.isAfter(max)) {
          this.model = '';
          this.$emit('input', this.model);
          this.$nextTick(function() { self.$validator.validate(self.name); });
        }
      }
    }
  },
  mixins: [field],
  props: {
    decades: false,
    dateMask: {
      default: false,
      type: Boolean
    },
    maxDate: {
      default: null,
      type: String
    },
    pastDates: {
      default: true,
      type: Boolean
    },
    format: {
      default: "DD-MM-YYYY",
      type: String
    },
    placeholder: {
        default: '',
        type: String
      },
    isRequired: {
      default: false,
      type: Boolean,
    }
  }
};
</script>

<style>
.bootstrap-datetimepicker-widget .list-unstyled {
  list-style: none;
  padding: 0;
  margin: 0;
}
.bootstrap-datetimepicker-widget.dropdown-menu {
  position: absolute;
  background: #fff;
  border: 1px solid #dcdbdb;
}
.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td span.active {
  background-color: #26a69a;
}
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #006c5f;
}
.v-input__datetimepicker.v-input__error--border .v-input__field {
  border-color: red;
}
.v-input__datetimepicker.v-input__error--border {
  box-shadow: none;
}
</style>